import { HandballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const YellowCardPopup = new PopupBuilder('YellowCard', {
  incident_id: HandballIncidentId.YellowCard,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
